import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    autoLoad: { type: Boolean, default: false },
  };

  connect() {
    if (this.autoLoadValue) {
      document.body.classList.add("overflow-y-hidden");
    }

    this.onFrameMissing = this.onFrameMissing.bind(this);
    document.addEventListener("turbo:frame-missing", this.onFrameMissing);
  }

  disconnect() {
    document.removeEventListener("turbo:frame-missing", this.onFrameMissing);
  }

  open() {
    document.body.classList.add("overflow-y-hidden");
  }

  close(e) {
    e.preventDefault();
    this.element.remove();
    document.body.classList.remove("overflow-y-hidden");
  }

  closeClassic(e) {
    e.preventDefault();
    this.element.classList.add("hidden");
    document.body.classList.remove("overflow-y-hidden");
  }

  onFrameMissing(event) {
    if (event.target.id === "modal" || event.target.id === "sub-modal") {
      document.body.classList.remove("overflow-y-hidden");
    }
  }
}
